import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PromoGuard } from '@personal-area/global/promo';

import { HomeComponent } from './home/home.component';
import { RewardsHubComponent } from './rewards-hub.component';

const routes: Routes = [
  {
    path: '',
    component: RewardsHubComponent,
    data: { title: 'rewards-hub.title' },
    children: [
      {
        path: '',
        component: HomeComponent,
        pathMatch: 'full',
      },
      {
        path: 'vps',
        loadChildren: () =>
          import('@personal-area/global/rewards-hub/vps/feature-vps').then(
            (m) => m.VpsModule,
          ),
        canActivate: [PromoGuard],
        data: { promo: 'vps' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class RewardsHubRoutingModule {}
